import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig } from "@angular/material/legacy-dialog";
import * as _ from "lodash";
import { first } from "rxjs/operators";
import * as moment from "moment";
import { Subscription } from "rxjs";

import { AppGlobals } from "../../app.globals";
import { IUser } from "../../_models";
import { HousingService, AlertService, MediaWatcherService, LookupsService } from "../../_services";
import { UnSavedChangesDialogComponent } from "../../_components/unSavedChangesDialog/unSavedChangesDialog.component";

@Component({
    templateUrl: "arrivalDialog.component.html",
    styleUrls: ["arrivalDialog.component.css"]
})
export class ArrivalDialogComponent implements OnInit, OnDestroy {
    agreementConfirmationFormGroup: UntypedFormGroup;
    agreementConfirmation2FormGroup: UntypedFormGroup;
    arrivalFormGroup: UntypedFormGroup;
    allocationPeriod: string;
    currentUser: IUser;
    //scholasticPeriodId: number;
    //housingProgramId?: number;
    housingStudentApplicationId: number;
    showAdditionalInformation = false;
    moveOutDate: Date;
    defaultMoveInDate: any;
    checkInDates = [];
    minCheckInDate: any;
    checkInLocations = [];
    showArrivalInformation = false;
    allowEdit = true;
    isMobile = false;
    mediaWatcherSubscription: Subscription;
    defaultCheckInLocation = null;

    constructor(private dialogRef: MatDialogRef<ArrivalDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private formBuilder: UntypedFormBuilder,
        public dialog: MatDialog,
        private housingService: HousingService,
        private appGlobals: AppGlobals,
        private alertService: AlertService,
        private mediaWatcherService: MediaWatcherService,
        private lookupsService: LookupsService) {
        this.currentUser = data.currentUser;
        this.allocationPeriod = data.allocationPeriod;
        //this.scholasticPeriodId = data.scholasticPeriodId;
        //this.housingProgramId = data.housingProgramId;
        this.housingStudentApplicationId = data.housingStudentApplicationId;
        this.moveOutDate = data.moveOutDate;
        this.defaultMoveInDate = data.defaultMoveInDate;
        this.checkInDates = data.checkInDates;
        this.checkInLocations = data.checkInLocations;
        this.allowEdit = data.allowEdit;

        this.minCheckInDate = moment((_.minBy(this.checkInDates, "checkInDate") as any).checkInDate, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
    }

    ngOnDestroy() {
        this.mediaWatcherSubscription.unsubscribe();
    }

    ngOnInit() {
        //this.googleAnalyticsService.logPageView("/housingArrivalForm");

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;
        });

        this.initializeForm();

        this.defaultCheckInLocation = this.checkInLocations.find(f => f.housingCheckInLocationId === 2);

        if (!this.checkInLocations.find(f => f.housingCheckInLocationId === 2)) {
            this.lookupsService.getHousingCheckinLocations()
                .pipe(first())
                .subscribe((result: any) => {
                    const temp = result.find(f => f.id === 2);

                    this.defaultCheckInLocation = {
                        id: 0,
                        housingCheckInLocationAddress: temp.address,
                        housingCheckInLocationDescription: temp.description,
                        housingCheckInLocationId: temp.id
                    };
                });
        }

        if (!this.allowEdit) {
            this.housingService.getHousingArrivalInformation(this.housingStudentApplicationId)
                .pipe(first())
                .subscribe((result: any) => {
                    if (result) {
                        if (result.housingCheckInLocationId) {
                            const checkInDateId = (_.find(this.checkInDates, { "checkInDate": result.arrivalDate }) as any).id;

                            this.arrivalFormGroup.get("checkInDateId").setValue(checkInDateId);
                            this.arrivalFormGroup.get("checkInLocationId").setValue(result.housingCheckInLocationId);
                        } else {
                            this.arrivalFormGroup.get("checkInDateId").setValue(2);
                            this.arrivalFormGroup.get("otherCheckInDate").setValue(result.arrivalDate);
                        }

                        this.arrivalFormGroup.get("shuttleServiceRequired").setValue(result.shuttleServiceRequired);

                        this.arrivalFormGroup.get("airlineCarrier").setValue(result.airlineCarrier);
                        this.arrivalFormGroup.get("flightNo").setValue(result.flightNumber);
                        this.arrivalFormGroup.get("arrivalTime").setValue(result.arrivalTime.split(":").slice(0, -1).join(":"));
                        this.arrivalFormGroup.get("departureCity").setValue(result.departureCity);
                        this.arrivalFormGroup.get("isDirectFlight").setValue(result.hasDirectFlight);
                        this.arrivalFormGroup.get("finalLayoverCity").setValue(result.finalLayoverCity);
                    }

                    this.onChanges();
                });
        } else
            this.onChanges();
    }

    initializeForm() {
        this.agreementConfirmationFormGroup = this.formBuilder.group({
            consent: [{ value: "", disabled: false }, Validators.required],
        });

        this.agreementConfirmation2FormGroup = this.formBuilder.group({
            consent2: [{ value: "", disabled: false }, Validators.required],
        });

        this.arrivalFormGroup = this.formBuilder.group({
            checkInDateId: [{ value: this.defaultMoveInDate.id, disabled: !this.allowEdit }, Validators.required],
            otherCheckInDate: [{ value: "", disabled: true }, Validators.required],
            checkInLocationId: [{ value: "", disabled: !this.allowEdit }, Validators.required],
            shuttleServiceRequired: [{ value: false, disabled: true }, Validators.required],
            airlineCarrier: [{ value: "", disabled: !this.allowEdit }, [Validators.required, Validators.maxLength(150), Validators.minLength(3)]],
            flightNo: [{ value: "", disabled: !this.allowEdit }, [Validators.required, Validators.maxLength(15), Validators.minLength(3)]],
            arrivalTime: [{ value: "", disabled: !this.allowEdit }, Validators.required],
            departureCity: [{ value: "", disabled: !this.allowEdit }, [Validators.required, Validators.maxLength(150), Validators.minLength(3)]],
            isDirectFlight: [{ value: true, disabled: !this.allowEdit }, Validators.required],
            finalLayoverCity: [{ value: "", disabled: true }, [Validators.required, Validators.maxLength(150), Validators.minLength(3)]]
        });
    }

    onChanges() {
        this.arrivalFormGroup.get("checkInDateId").valueChanges
            .subscribe(selectedCheckInDateId => {
                if (selectedCheckInDateId === 0) {
                    this.arrivalFormGroup.get("otherCheckInDate").enable();

                    if (this.defaultCheckInLocation.id === 0) {
                        this.checkInLocations.push(this.defaultCheckInLocation);

                        this.checkInLocations = _.orderBy(this.checkInLocations, "housingCheckInLocationDescription");
                    }

                    this.arrivalFormGroup.get("checkInLocationId").reset(2);
                    this.arrivalFormGroup.get("checkInLocationId").disable();

                    this.arrivalFormGroup.get("shuttleServiceRequired").reset(false);
                    this.arrivalFormGroup.get("shuttleServiceRequired").disable();
                } else {
                    this.arrivalFormGroup.get("otherCheckInDate").reset();
                    this.arrivalFormGroup.get("otherCheckInDate").disable();

                    if (this.defaultCheckInLocation.id === 0) {
                        const index = this.checkInLocations.findIndex(((elt) => elt.id === this.defaultCheckInLocation.id) as any);

                        if (index !== -1)
                            this.checkInLocations.splice(index, 1);

                        this.checkInLocations = _.orderBy(this.checkInLocations, "housingCheckInLocationDescription");
                    }

                    this.arrivalFormGroup.get("checkInLocationId").reset();
                    this.arrivalFormGroup.get("checkInLocationId").enable();
                }
            });

        this.arrivalFormGroup.get("checkInLocationId").valueChanges
            .subscribe(checkInLocationId => {
                if (checkInLocationId) {
                    const checkInLocation = this.checkInLocations.find(f => f.housingCheckInLocationId === checkInLocationId);

                    this.arrivalFormGroup.get("shuttleServiceRequired").reset(false);

                    if (checkInLocation && checkInLocation.housingCheckInLocationDescription.indexOf("Airport") !== -1) {
                        this.arrivalFormGroup.get("shuttleServiceRequired").enable();
                    } else
                        this.arrivalFormGroup.get("shuttleServiceRequired").disable();
                }
            });

        this.arrivalFormGroup.get("airlineCarrier").valueChanges
            .subscribe(value => {
                if (value && value.trim().length === 0)
                    this.arrivalFormGroup.get("airlineCarrier").reset();
            });

        this.arrivalFormGroup.get("flightNo").valueChanges
            .subscribe(value => {
                if (value && value.trim().length === 0)
                    this.arrivalFormGroup.get("flightNo").reset();
            });

        this.arrivalFormGroup.get("departureCity").valueChanges
            .subscribe(value => {
                if (value && value.trim().length === 0)
                    this.arrivalFormGroup.get("departureCity").reset();
            });

        this.arrivalFormGroup.get("finalLayoverCity").valueChanges
            .subscribe(value => {
                if (value && value.trim().length === 0)
                    this.arrivalFormGroup.get("finalLayoverCity").reset();
            });

        this.arrivalFormGroup.get("isDirectFlight").valueChanges
            .subscribe(isDirectFlight => {
                if (!isDirectFlight) {
                    this.arrivalFormGroup.get("finalLayoverCity").enable();
                } else {
                    this.arrivalFormGroup.get("finalLayoverCity").reset();
                    this.arrivalFormGroup.get("finalLayoverCity").disable();
                }
            });
    }

    get agreementConfirmationFormControls() { return this.agreementConfirmationFormGroup.controls; }

    get arrivalFormControls() { return this.arrivalFormGroup.controls as any; }

    saveArrivalInformation(submitBtn: HTMLButtonElement) {
        if (this.arrivalFormGroup.invalid) {
            return;
        }

        if (this.arrivalFormGroup.dirty) {
            setTimeout(() => {
                submitBtn.disabled = true;
            }, 0);

            let checkInDate = null;

            if (this.arrivalFormControls.checkInDateId.value !== 0)
                checkInDate = moment((_.find(this.checkInDates, { "id": this.arrivalFormControls.checkInDateId.value }) as any).checkInDate).format("YYYY-MM-DD");
            else
                checkInDate = moment(this.arrivalFormControls.otherCheckInDate.value).format("YYYY-MM-DD");

            const saveModel = {
                housingStudentApplicationId: this.housingStudentApplicationId,
                arrivalDate: checkInDate,
                housingCheckInLocationId: this.arrivalFormControls.checkInDateId.value !== 0 ? this.arrivalFormControls.checkInLocationId.value : null,
                shuttleServiceRequired: this.arrivalFormControls.shuttleServiceRequired.value ? this.arrivalFormControls.shuttleServiceRequired.value : false,
                airlineCarrier: this.arrivalFormControls.airlineCarrier.value,
                flightNumber: this.arrivalFormControls.flightNo.value,
                arrivalTime: moment(this.arrivalFormControls.arrivalTime.value, "hh:mm A").format("HH:mm"),
                departureCity: this.arrivalFormControls.departureCity.value,
                hasDirectFlight: this.arrivalFormControls.isDirectFlight.value ? this.arrivalFormControls.isDirectFlight.value : false,
                finalLayoverCity: !this.arrivalFormControls.finalLayoverCity.value || !this.arrivalFormControls.finalLayoverCity.value.trim() ? null : this.arrivalFormControls.finalLayoverCity.value.trim(),
                pickupFromAirport: this.arrivalFormControls.checkInDateId.value !== 0
            };

            this.housingService.insertArrivalInformation(saveModel)
                .pipe(first())
                .subscribe(() => {
                    this.alertService.showMessage("Arrival Information Successfully Submitted.", "Housing Application", this.appGlobals.alertMessageTypes.success);

                    this.dialogRef.close(true);
                });
        }
    }

    close() {
        if (this.arrivalFormGroup.dirty) {
            //show unsaved changes dialog
            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.width = this.isMobile ? "60vw" : "30vw";
            dialogConfig.height = "auto";
            dialogConfig.panelClass = "unSavedChanges-dialog-container";

            const dialogRef = this.dialog.open(UnSavedChangesDialogComponent, dialogConfig);

            dialogRef.afterClosed().subscribe(result => {
                if (result === "confirm") {
                    this.dialogRef.close();
                }
            });
        } else {
            this.dialogRef.close();
        }
    }
}